import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Confirmed = createSvgIcon(
  <path d="m11.006 16.92 7.457-8.388-1.681-1.495-6.038 6.792-3.795-3.035-1.405 1.757 5.462 4.37Z M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z" />,
  'Confirmed'
);

export { Confirmed };